module.exports = __webpack_public_path__ + "static/media/menu.4d7a7b5b.png";